<template>
  <span>
    <v-carousel
      cycle
      height="400"
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i" :src="slide.src">
        <v-row class="fill-height" align="center" justify="center">
          <div
            v-if="browserSize.sm === true || browserSize.xs === true"
            class="display-1"
            style="font-weight: 900; text-shadow: 3px 2px #000000"
          >
            {{ slide.txt }}
          </div>
          <div
            v-else
            class="display-2"
            style="font-weight: 900; text-shadow: 3px 2px #000000"
          >
            {{ slide.txt }}
          </div>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </span>
</template>

<script>
export default {
  name: "Carousel",

  data() {
    return {
      slides: [
        {
          txt: "Pasja",
          src: require("../assets/back.jpg"),
        },
        {
          txt: "Fizjoterapia",
          src: require("../assets/treatment.jpg"),
        },
        {
          txt: "Masaż",
          src: require("../assets/traditional-chinese.jpg"),
        },
      ],
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.display-2 {
  color: white;
  text-shadow: 4px 3px 12px rgba(92, 104, 115, 1);
  font-weight: 500;
  text-align: center;
}
.v-window-item {
  transition: all 0.5s ease-out;
}
</style>
